import axios from 'axios'
import { getAppHost, getAppEndpointVersion } from 'helpers'

// Generic function to submit dynamic forms
export const submitDynamicForm = async (app, appSettings, endpoint, method, payload) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/${endpoint}`
    
    const config = {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    }

    let response
    switch (method.toUpperCase()) {
      case 'POST':
        response = await axios.post(baseURL, payload, config)
        break
      case 'PUT':
        response = await axios.put(baseURL, payload, config)
        break
      case 'PATCH':
        response = await axios.patch(baseURL, payload, config)
        break
      case 'DELETE':
        response = await axios.delete(baseURL, config)
        break
      case 'GET':
      default:
        response = await axios.get(baseURL, config)
        break
    }
    
    return response.data
  } catch (error) {
    throw error
  }
}

// Generic function to fetch dynamic data (for form options, etc.)
export const fetchDynamicData = async (app, appSettings, endpoint) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(app)}/${endpoint}`
    
    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })
    
    return response.data
  } catch (error) {
    throw error
  }
}
